import { useState } from 'react';

import { getGroupsUsersAPI } from '../services/groupsAPI'
import { getPOIGroupUsersAPI } from '../services/poiGroupUsersAPI';

import { useLoading } from '../contexts/LoadingContext';
import { useError } from '../contexts/ErrorContext';

/**
 * 
 * Gets user name options for dropdowns - for permission groups and poi groups
 * 
 * @returns {DropdownOption[]} userNameOptionsPermissionGroup
 * @returns {Function} fetchUsersForPermissionGroup
 * @returns {DropdownOption[]} userNameOptionsPoiGroup
 * @returns {Function} fetchUsersForPoiGroup
 * 
 * @category Hooks - Dropdown Options
 */
const useUserOptionsGroups = () => {
    const [userNameOptionsPermissionGroup, setUserNameOptionsPermissionGroup] = useState([]);
    const [userNameOptionsPoiGroup, setUserNameOptionsPoiGroup] = useState([]);
    
    const { showLoading, hideLoading } = useLoading();
    const { showError } = useError();
    

    //fetch all users for a permission group
    const fetchUsersForPermissionGroup = async(GroupID) => {
        showLoading("Getting users for group...")
    
        try {
            const response = await getGroupsUsersAPI(GroupID);
    
            if (!response.success) {
                throw new Error(response.message);
            }
    
            const users = response.data;
                
            const userOptions = users.map(user => ({
                value: user.UserID,
                label: `${user.First_Name} ${user.Last_Name}`
            }));
                
            setUserNameOptionsPermissionGroup(userOptions);
    
        } catch (error) {
            showError(`Error getting users for this permission group - ${error.message}`);
        } finally {
            hideLoading();
        }
    };

    //fetch all users for a poi group
    const fetchUsersForPoiGroup = async(poiGroupId) => {
        showLoading("Getting users for group...")
    
        try {
            const response = await getPOIGroupUsersAPI(poiGroupId);
    
            if (!response.success) {
                throw new Error(response.message);
            }
    
            const users = response.data;
                
            const userOptions = users.map(user => ({
                value: user.UserID,
                label: `${user.First_Name} ${user.Last_Name}`,
                IsEditor: user.IsEditor
            }));
                
            setUserNameOptionsPoiGroup(userOptions);
    
        } catch (error) {
            showError(`Error getting users for this POI group - ${error.message}`);
        } finally {
            hideLoading();
        }
    };
    

    return { 
        userNameOptionsPermissionGroup, 
        fetchUsersForPermissionGroup,
        userNameOptionsPoiGroup,
        fetchUsersForPoiGroup, 
    };
};

export default useUserOptionsGroups;